/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  $('body').on('click','.back-to-add',function(){
  $('html,body').animate({
                scrollTop: $('.multiple_variants_product').offset().top
            }, 1000);
});
  });


var get_include_tab = $('.main__description_tabs').find('b[data-mce-fragment="1"]').html();
var get_include_content = $('.main__description_tabs').find('b[data-mce-fragment="1"]').next().html();

$('.main__description_tabs .tab').prepend('<button class="tablinks selected" id="defaultOpen" onclick="openCity(event, \'whats included\')" >' + get_include_tab + '</button>');
$('.main__description_tabs .tab').after("<div id='whats included' class='tabcontent' style='display:block;'>"+get_include_content+"</div>");
$('.main__description_tabs').find("button#defaultOpen").removeAttr('id');

function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" selected", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " selected";
}

// Get the element with id="defaultOpen" and click on it
if(document.getElementById("defaultOpen") !== null)
{
document.getElementById("defaultOpen").click();
}



var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
    
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}



$('body').on('change','.product-form.multiple_variants_product .product-form__variants .block-swatch__radio',function(){

var currentPrice = parseFloat($(this).next().find('.variants_price').attr('var-price')); 
var moneyPrice = $(this).next().find('.variants_price').attr('price'); 
var metafield = $(this).attr('data-metavalue');
  
if (!isNaN(currentPrice) && currentPrice > 0) {
    if(!isNaN(metafield) && metafield > 0){
      var per_day = '$'+(currentPrice / metafield).toFixed(2); 
    }
    else{
      var per_day = '$'+(currentPrice / 30).toFixed(2);   
    }
} else {
   
}

 $('.product-form__variants').find('.per-day-price').html('<b>'+moneyPrice+'</b> / '+per_day+'  Per Day');
  
});


//   window.Shoppad = window.Shoppad || {},
//   window.Shoppad.apps = window.Shoppad.apps || {},
//   window.Shoppad.apps.infiniteoptions = {
//     ready: function() {

//       function callback() {
//         $('#infiniteoptions-container .datepicker').datepicker({
//           inline: true,
//           altField: '#infiniteoptions-container .datepicker input[type=text]',
//           onSelect: function() {
//             $('#infiniteoptions-container .ui-datepicker-inline').hide();
//           }
//         });

//         $('#infiniteoptions-container .datepicker input[type=text]').change(function(){
//           $('#infiniteoptions-container .datepicker').datepicker('setDate', $(this).val());
//         });

//         $('#infiniteoptions-container .datepicker').datepicker( "setDate", '' );

//         $('#infiniteoptions-container .datepicker input[type=text]').attr('readonly','true');

//         $('#infiniteoptions-container .ui-datepicker-inline').hide();

//         $('#infiniteoptions-container .datepicker input[type=text]').on('click touchstart', function (e) {
//               $('#infiniteoptions-container .ui-datepicker-inline').show();
//         });
//       }

//       $(document).on('mouseup touchstart', function(e) {
//         var isDatePickerInput = $('#infiniteoptions-container .datepicker input').is(e.target);
//         var isDatePicker = $('#infiniteoptions-container .ui-datepicker-inline').is(e.target);
//         var isChildOfDatePicker = $('#infiniteoptions-container .ui-datepicker-inline').has(e.target).length;

//         // If the target of the click isn't the text input, the date picker, or a descendant of the date picker
//         if (!isDatePickerInput && !isDatePicker && !isChildOfDatePicker) {
//           $('#infiniteoptions-container .ui-datepicker-inline').hide();
//         }
//       });

//       if (window.jQuery.fn.datepicker) {
//         callback();
//       } else {
//         var script = document.createElement('script');
//         script.src = '//code.jquery.com/ui/1.10.2/jquery-ui.js';
//         script.onload = callback;
//         document.getElementsByTagName('head')[0].appendChild(script);
//       }
//     }
//   };




